import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var AwardsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#awards-1__a)",
                            children: [
                                _jsx("path", {
                                    d: "M20.045 14.395c0-1.29-.5-2.5-1.41-3.41a4.787 4.787 0 00-3.41-1.41c-1.29 0-2.5.5-3.41 1.41-.91.91-1.41 2.12-1.41 3.41s.5 2.5 1.41 3.41c.18.18.37.32.57.47v3.73c0 .36.19.69.51.87.15.09.32.13.49.13.17 0 .35-.05.51-.14l1.33-.79 1.33.79c.31.18.69.19 1.01 0 .32-.19.51-.51.51-.87v-3.73c.2-.14.39-.29.57-.47.91-.91 1.41-2.12 1.41-3.41l-.01.01zm-6.82-2c.53-.53 1.24-.83 2-.83s1.46.29 2 .83c.53.53.83 1.24.83 2s-.29 1.46-.83 2c-1.07 1.07-2.93 1.06-3.99 0-.53-.53-.83-1.25-.83-2s.3-1.47.83-2h-.01zm2.84 7.84l-.33-.2a.984.984 0 00-1.02 0l-.33.2v-1.11c.28.05.56.08.84.08.28 0 .56-.03.84-.08v1.11zm-9.66-13.07h9.75c.55 0 1-.45 1-1s-.45-1-1-1h-9.75c-.55 0-1 .45-1 1s.45 1 1 1zm0 3.25h2.79c.55 0 1-.45 1-1s-.45-1-1-1h-2.79c-.55 0-1 .45-1 1s.45 1 1 1z"
                                }),
                                _jsx("path", {
                                    d: "M22.495 1.755c-.48-.48-1.15-.76-1.83-.76H3.345c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v13.04c0 .69.27 1.34.76 1.83s1.14.76 1.83.76h5.82c.55 0 1-.45 1-1s-.45-1-1-1h-5.82a.59.59 0 01-.42-.17.59.59 0 01-.17-.42V3.585c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h17.31c.16 0 .31.06.42.17.11.11.17.26.17.42v13.04c0 .16-.06.31-.17.42a.59.59 0 01-.42.17h-.35c-.55 0-1 .45-1 1s.45 1 1 1h.35c.68 0 1.35-.28 1.83-.76.49-.49.76-1.14.76-1.83V3.585c0-.69-.27-1.34-.76-1.83h.01z"
                                }),
                                _jsx("path", {
                                    d: "M15.225 15.795c.37 0 .73-.15.98-.41.26-.26.42-.62.42-.99s-.15-.73-.41-.98c-.26-.26-.62-.41-.99-.41s-.73.15-.99.41-.41.62-.41.99.15.73.41.99.62.41.99.41v-.01z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "awards-1__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
AwardsIcon.isCarinaIcon = true;
export default AwardsIcon;
